import { Box, Loader } from '@wix/design-system';
import React from 'react';
import { useUpgradeComplete, UpgradeCompleteContent } from '../features/upgradeComplete';

type UpgradeCompletePageProps = {};

export const UpgradeComplete: React.FC<UpgradeCompletePageProps> = () => {
  const { isLoading, isRedirecting } = useUpgradeComplete();

  if (isLoading) {
    return (
      <Box height="100vh" width="100%" align="center" verticalAlign="middle">
        <Loader />
      </Box>
    );
  }

  return <UpgradeCompleteContent isRedirecting={isRedirecting} />;
};
